module.exports = __webpack_public_path__ + "nlogout_icon.svg";